"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const giftcardoutlined = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-giftcardoutlined` : '') + (description ? ` desc-giftcardoutlined` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-giftcardoutlined"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-giftcardoutlined"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 5.257V18.75c0 .244.059.377.108.451a.57.57 0 0 0 .227.19 1.098 1.098 0 0 0 .422.109H21.75c.244 0 .377-.059.451-.108a.57.57 0 0 0 .19-.227 1.098 1.098 0 0 0 .109-.422V5.25c0-.244-.059-.377-.108-.451a.57.57 0 0 0-.227-.19 1.096 1.096 0 0 0-.422-.109H2.25c-.244 0-.377.059-.451.108a.569.569 0 0 0-.19.227 1.095 1.095 0 0 0-.109.422ZM21.75 3.75V3H2.25c-.506 0-.936.129-1.283.36a2.066 2.066 0 0 0-.7.805A2.593 2.593 0 0 0 0 5.208v.026L0 5.243v.005s0 .002.75.002H0v13.5c0 .506.129.936.36 1.283.229.343.528.562.805.7A2.594 2.594 0 0 0 2.208 21h.026l.009.001h.005s.002 0 .002-.75V21h19.5c.506 0 .936-.129 1.283-.36.343-.229.562-.528.7-.805A2.594 2.594 0 0 0 24 18.792v-.026l.001-.009v-.006l-.75-.001H24V5.25c0-.506-.129-.936-.36-1.283a2.066 2.066 0 0 0-.805-.7A2.593 2.593 0 0 0 21.792 3h-.026L21.757 3h-.006l-.001.75Zm-9.736 6.505L9.788 8.029a2.658 2.658 0 1 0-1.88 4.537h2.795l-2.47 2.47a.75.75 0 1 0 1.061 1.06l2.72-2.72 2.72 2.72a.75.75 0 0 0 1.06-1.06l-2.47-2.47h2.796a2.658 2.658 0 1 0-1.88-4.537l-2.226 2.226Zm4.332-1.483a1.158 1.158 0 0 0-1.045.317l-1.977 1.977h2.796a1.158 1.158 0 0 0 .226-2.294Zm-8.664 0a1.158 1.158 0 0 1 1.045.317l1.977 1.977H7.908a1.158 1.158 0 0 1-.226-2.294Z",
    fill: "#000"
  }));
};
var _default = exports.default = giftcardoutlined;